export default (bookmarks) => [...bookmarks]
  .sort((a, b) => b.bookmark.modifiedAt.diff(a.bookmark.modifiedAt));
